import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Category} from "../../models/category";

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";
import {CustomerDescriptionEditDialogComponent} from "./customerDescriptionEditDialog.component";
import {first} from "rxjs/operators";
import {UserService} from "../../services";

@Component({
    selector: 'customer-form-dialog',
    templateUrl: './customerContactDetailsDialog.component.html',
    styleUrls: ['./customerContactDetailsDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CustomerContactDetailsDialogComponent {
    action: string;
    customer: User;
    dialogTitle: string;
    dialogRef: any;

    /**
     * Constructor
     *
     * @param {MatDialogRef<CustomerDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<CustomerContactDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private userService: UserService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.customer = _data.customer;
    }

    editCustomerDescription(customer: User) {
        this.dialogRef = this._matDialog.open(CustomerDescriptionEditDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                action: 'edit',
                customer: customer
            },
            width: '500px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                let customerData = response.getRawValue();
                customer.description = customerData.description;

                const formData = new FormData();
                Object.keys(customer).forEach(key => {
                    if (!customer[key]) {
                        customer[key] = '';
                    }

                    formData.append(key, customer[key]);
                });

                this.userService.updateCustomer(customer.id, formData, customer)
                    .pipe(first())
                    .subscribe(
                        (customer: User) => {
                            this.customer = customer
                        },
                        error => {
                            console.log(error);
                        });

            }, (err) => {
                console.log(err);
            });
    }

}
